import { render, staticRenderFns } from "./ImageTags.vue?vue&type=template&id=f05d3834&"
import script from "./ImageTags.vue?vue&type=script&lang=js&"
export * from "./ImageTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports